__turbopack_context__.v({
  "buySectionContainer": "n7AdlW_buySectionContainer",
  "offerFlexContainer": "n7AdlW_offerFlexContainer",
  "offerTag": "n7AdlW_offerTag",
  "priceContainer": "n7AdlW_priceContainer",
});
